import {
  getNoteLinkedGroupAdapters,
  isKnownNoteLinkedGroupAdapter,
} from 'notebook/notes/groups/NoteLinkedGroupAdapters';
import {UnknownNoteLinkedGroup} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import getNotePartType from 'notebook/notes/util/getNotePartType';
import {TABLE_OPS} from 'notebook/tables/augmentNotePartTablesWithValues';
import {NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';

/**
 * Returns the table-bearing note parts for a given note part.
 * - For a NOTE_LINKED_GROUP that opts into entry-level evaluation,
 *   returns the group's contained table note parts (filtered to TABLE_OPS types).
 * - For a NOTE_LINKED_GROUP that does NOT opt in, returns [].
 * - For a regular table note part (has TABLE_OPS entry), returns [notePart].
 * - For a non-table note part (text, etc.), returns [].
 */
export function getTableNoteParts(notePart: NotePart): Array<NotePart> {
  const type = getNotePartType(notePart);
  if (type === NoteLinkedObjectType.NOTE_LINKED_GROUP && notePart.item) {
    const group = notePart.item as UnknownNoteLinkedGroup;
    if (!isKnownNoteLinkedGroupAdapter(group.kind)) {
      return [];
    }
    const adapter = getNoteLinkedGroupAdapters()[group.kind];
    if (!adapter.supportsEntryLevelEvaluation()) {
      return [];
    }
    return group.containedNoteParts.filter((cp) => {
      const cpType = getNotePartType(cp);
      return cpType != null && TABLE_OPS[cpType];
    });
  }
  if (type != null && TABLE_OPS[type]) {
    return [notePart];
  }
  return [];
}

/**
 * Returns all table-bearing note parts across an entire array of note parts.
 * Flattens NLG groups into their inner table note parts.
 */
export function getAllTableNoteParts(noteParts: Array<NotePart>): Array<NotePart> {
  return noteParts.flatMap((notePart) => getTableNoteParts(notePart));
}
